<template>
    <div>
        <v-container fluid>
            <v-row no-gutters>
                <v-col :cols="6">
                    <h1 class="headline font-weight-light mb-3">
                        Cases Project
                    </h1>
                </v-col>
                <v-col :cols="6" class></v-col>
            </v-row>
        </v-container>
        <v-row class="justify-center">
            <v-col
                cols="6"
                sm="5"
                md="2"
                lg="2"
                class="cur-p"
                v-for="(item, index) in arr_card"
                :key="index + 1"
            >
                <v-card @click="selectCard(index + 1, item.project_id)">
                    <v-list-item two-line>
                        <v-list-item-content>
                            <b style="font-size:15px;">
                                {{ item.project_name }}
                            </b>
                        </v-list-item-content>
                        <v-btn
                            fab
                            dark
                            small
                            elevation="0"
                            :color="
                                index + 1 === chk_active_btn
                                    ? 'orange'
                                    : 'teal darken-1'
                            "
                        >
                            <span>{{ item.num_cases }}</span>
                        </v-btn>
                    </v-list-item>
                    <v-system-bar
                        :height="4"
                        dark
                        :color="
                            index + 1 === chk_active_btn ? 'orange' : 'white'
                        "
                    ></v-system-bar>
                </v-card>
            </v-col>
        </v-row>

        <v-card>
            <v-simple-table class="mt-5">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="grey lighten-2 text-center">
                                NonHP Information
                            </th>
                            <th class="grey lighten-2 text-center">Status</th>
                            <th class="grey lighten-2 text-center">
                                HP Information
                            </th>
                            <th class="grey lighten-2 text-center">Status</th>
                            <th class="grey lighten-2 text-center">Zone CE</th>
                            <th class="grey lighten-2 text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, id) in data_case.data" :key="id">
                            <!-- <td class="pa-3">
                                <v-chip small label dark class="teal mr-2">
                                    <span class="font-weight-medium">{{
                                        item.project_name
                                    }}</span>
                                </v-chip>

                                <span class="font-weight-bold">
                                    {{ item.nonhp_case_id }}
                                </span>
                                <br />
                                <span class="font-weight-bold">
                                    Cso no : {{ item.nonhp_case_refer }}
                                </span>
                                <br />
                                <span
                                    class="overline font-weight-light text-lowercase"
                                >
                                    owner : {{ item.nonhp_created_name }}
                                    {{ item.created_date }}
                                </span>
                                <div v-if="item.site_name">
                                    <span v-if="item.site_name.length < 150">{{
                                        item.site_name
                                    }}</span>
                                    <span v-else>{{
                                        item.site_name.substring(0, 150) + "..."
                                    }}</span>
                                </div>

                                <div
                                    v-if="item.case_title"
                                    class="font-weight-medium"
                                >
                                    <span v-if="item.case_title.length < 70">{{
                                        item.case_title
                                    }}</span>
                                    <span v-else>{{
                                        item.case_title.substring(0, 70) + "..."
                                    }}</span>
                                </div>
              </td>-->
                            <td class="pa-3">
                                <v-chip small label dark class="teal mr-2">
                                    <span class="font-weight-medium">
                                        {{ item.project_name }}
                                    </span>
                                </v-chip>

                                <span class="font-weight-bold">{{
                                    item.case_id + " - " + item.subcase
                                }}</span>
                                <span
                                    class="font-weight-light text-lowercase"
                                    >{{ " " + item.case_type }}</span
                                >
                                <br />
                                <span
                                    class="overline font-weight-light text-lowercase"
                                >
                                    owner : {{ item.created_name }}
                                    {{ item.created_date }}
                                </span>
                                <div v-if="item.site_name">
                                    <span v-if="item.site_name.length < 150">
                                        {{ item.site_name }}
                                    </span>
                                    <span v-else>
                                        {{
                                            item.site_name.substring(0, 150) +
                                                "..."
                                        }}
                                    </span>
                                </div>

                                <div
                                    v-if="item.case_title"
                                    class="font-weight-medium"
                                >
                                    <span v-if="item.case_title.length < 70">
                                        {{ item.case_title }}
                                    </span>
                                    <span v-else>
                                        {{
                                            item.case_title.substring(0, 70) +
                                                "..."
                                        }}
                                    </span>
                                </div>

                                <div
                                    class="overline font-weight-light text-uppercase"
                                >
                                    <span
                                        v-for="(part, index_part) in item.parts"
                                        :key="index_part"
                                    >
                                        # ({{ part.subcase }})
                                        {{
                                            part.ponumber !== "null"
                                                ? part.ponumber
                                                : ""
                                        }}
                                        {{ part.part_name }} -
                                        {{
                                            part.ce_status
                                                ? part.ce_status
                                                : part.ship_date
                                                ? part.ship_date_x
                                                : part.status
                                        }}
                                        <br />
                                    </span>
                                </div>
                            </td>
                            <td>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            :color="item.main_status_color"
                                            fab
                                            dark
                                            v-on="on"
                                            x-small
                                            elevation="0"
                                        >
                                            <v-icon small>
                                                {{ item.main_status_icon }}
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ item.main_status_name }}</span>
                                </v-tooltip>
                                <span class="ml-2 font-weight-medium">
                                    {{ item.sub_status_name }}
                                </span>
                                <p
                                    v-if="
                                        item.project_name == 'CDAX' ||
                                            item.project_name == 'S-Print'
                                    "
                                    class="mt-2 font-weight-medium"
                                >
                                    CDAX : {{ item.status_name }}
                                </p>
                            </td>
                            <td class="pa-3">
                                <div v-if="item.hp_case_detail != null">
                                    <v-chip small label dark class="teal mr-2">
                                        <span class="font-weight-medium">
                                            {{
                                                item.hp_case_detail.project_name
                                            }}
                                        </span>
                                        <!-- project_name -->
                                    </v-chip>

                                    <span class="font-weight-bold">
                                        {{
                                            item.hp_case_detail.case_id +
                                                " - " +
                                                item.hp_case_detail.subcase
                                        }}
                                    </span>
                                    <span
                                        class="font-weight-light text-lowercase"
                                    >
                                        {{
                                            " " + item.hp_case_detail.case_type
                                        }}
                                    </span>
                                    <br />
                                    <span
                                        class="overline font-weight-light text-lowercase"
                                    >
                                        owner :
                                        {{ item.hp_case_detail.created_name }}
                                        {{ item.hp_case_detail.created_date }}
                                    </span>
                                    <div v-if="item.site_name">
                                        <span
                                            v-if="item.site_name.length < 150"
                                        >
                                            {{ item.hp_case_detail.site_name }}
                                        </span>
                                        <span v-else>
                                            {{
                                                item.hp_case_detail.site_name.substring(
                                                    0,
                                                    150
                                                ) + "..."
                                            }}
                                        </span>
                                    </div>

                                    <div
                                        v-if="item.case_title"
                                        class="font-weight-medium"
                                    >
                                        <span
                                            v-if="item.case_title.length < 70"
                                        >
                                            {{ item.hp_case_detail.case_title }}
                                        </span>
                                        <span v-else>
                                            {{
                                                item.hp_case_detail.case_title.substring(
                                                    0,
                                                    70
                                                ) + "..."
                                            }}
                                        </span>
                                    </div>

                                    <div
                                        class="overline font-weight-light text-uppercase"
                                    >
                                        <span
                                            v-for="(part, index_part) in item
                                                .hp_case_detail.parts"
                                            :key="index_part"
                                        >
                                            # ({{ part.subcase }})
                                            {{
                                                part.ponumber !== "null"
                                                    ? part.ponumber
                                                    : ""
                                            }}
                                            {{ part.part_name }} -
                                            {{
                                                part.ce_status
                                                    ? part.ce_status
                                                    : part.ship_date
                                                    ? part.ship_date_x
                                                    : part.status
                                            }}
                                            <br />
                                        </span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div v-if="item.hp_case_detail != null">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                :color="
                                                    item.hp_case_detail
                                                        .main_status_color
                                                "
                                                fab
                                                dark
                                                v-on="on"
                                                x-small
                                                elevation="0"
                                            >
                                                <v-icon small>
                                                    {{
                                                        item.hp_case_detail
                                                            .main_status_icon
                                                    }}
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>
                                            {{
                                                item.hp_case_detail
                                                    .main_status_name
                                            }}
                                        </span>
                                    </v-tooltip>
                                    <span class="ml-2 font-weight-medium">
                                        {{
                                            item.hp_case_detail.sub_status_name
                                        }}
                                    </span>
                                    <p
                                        v-if="
                                            item.hp_case_detail.project_name ==
                                                'CDAX' ||
                                                item.hp_case_detail
                                                    .project_name == 'S-Print'
                                        "
                                        class="mt-2 font-weight-medium"
                                    >
                                        CDAX :
                                        {{ item.hp_case_detail.status_name }}
                                    </p>
                                </div>
                            </td>
                            <!-- <td class="pa-3">
                                <span class="font-weight-bold">
                                    {{ item.hp_case_id }}
                                </span>
                                <span
                                    class="font-weight-light text-lowercase"
                                    >{{ " " + item.type }}</span
                                >
                                <br />
                                <span
                                    class="overline font-weight-light text-lowercase"
                                >
                                    owner : {{ item.hp_created_name }}
                                    {{ item.created_date }}
                                </span>
                                <div v-if="item.site_name">
                                    <span v-if="item.site_name.length < 150">{{
                                        item.site_name
                                    }}</span>
                                    <span v-else>{{
                                        item.site_name.substring(0, 150) + "..."
                                    }}</span>
                                </div>

                                <div
                                    v-if="item.case_title"
                                    class="font-weight-medium"
                                >
                                    <span v-if="item.case_title.length < 70">{{
                                        item.case_title
                                    }}</span>
                                    <span v-else>{{
                                        item.case_title.substring(0, 70) + "..."
                                    }}</span>
                                </div>
                            </td>
                            <td>
                                <v-tooltip v-if="item.main_status_name" bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            color="orange"
                                            fab
                                            dark
                                            v-on="on"
                                            x-small
                                            elevation="0"
                                        >
                                            <v-icon small>{{
                                                item.main_status_icon
                                            }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ item.main_status_name }}</span>
                                </v-tooltip>

                                <span class="ml-2 font-weight-medium">{{
                                    item.sub_status_name
                                }}</span>
                                <p
                                    v-if="item.project_name == 'CDAX'"
                                    class="mt-2 font-weight-medium"
                                >
                                    CDAX : {{ item.status_name }}
                                </p>
              </td>-->
                            <td class="text-center">
                                <p>{{ item.branch_name }}</p>
                                {{ item.engineer }}
                            </td>
                            <td>
                                <v-row>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="red darken-4"
                                                fab
                                                x-small
                                                v-on="on"
                                                @click="view(item.maincase_id)"
                                            >
                                                <v-icon
                                                    class="white--text"
                                                    small
                                                    >mdi-close-octagon</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span class="text--white"
                                            >Close Case</span
                                        >
                                    </v-tooltip>
                                    <view-more
                                        class="ml-2"
                                        :maincaseid="item.maincase_id"
                                    />
                                </v-row>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <div class="text-center pa-5">
                <v-pagination
                    @input="onPageChange"
                    v-model="pagination.current"
                    :length="data_case.last_page"
                    total-visible="10"
                    circle
                ></v-pagination>
            </div>
        </v-card>
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>{{
                text
            }}</v-snackbar>
        </div>
        <v-dialog
            ref="dialog"
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>View Detail Case</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-divider></v-divider>
                <div class="ml-10 mr-10">
                    <head-information
                        @closecase-click="closecase"
                        :status="chkstatus"
                        :detailcase="detailcase"
                    />
                    <view-caseinformation :detailcase="detailcase" />
                    <view-productinformation :detailcase="detailcase" />
                    <view-customerinformation :detailcase="detailcase" />
                    <view-engineerformation
                        :active_tab="0"
                        :status="condition.status"
                        :detailcase="detailcase"
                    />
                    <view-partformation :detailcase="detailcase" />
                    <view-loginformation
                        :status="condition.status"
                        :detailcase="detailcase"
                    />
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios"

import { mapState, mapMutations } from "vuex"

import TableViewCase from "../components/TableViewCase"
import MaterialStatsCard from "../../../components/StatsCard"

import HeadInformation from "../components/HeadInformation"
import ViewCaseInformation from "../components/ViewCaseInformation"
import ViewProductInformation from "../components/ViewProductInformation"
import ViewCustomerInformation from "../components/ViewCustomerInformation"
import ViewEngineerInformation from "../components/ViewEngineerInformation"
import ViewPartInformation from "../components/ViewPartInformation"
import ViewLogInformation from "../components/ViewLogInformation"
import ViewAttachInformation from "../components/ViewAttachInformation"
import ViewHpcInformation from "../components/ViewHpcInformation"

import ViewMore from "../../Inventory/components/ViewMore"

export default {
    components: {
        "base-material-stats-card": MaterialStatsCard,
        "head-information": HeadInformation,
        "view-caseinformation": ViewCaseInformation,
        "view-customerinformation": ViewCustomerInformation,
        "view-productinformation": ViewProductInformation,
        "view-loginformation": ViewLogInformation,
        "view-attachformation": ViewAttachInformation,
        "view-partformation": ViewPartInformation,
        "view-engineerformation": ViewEngineerInformation,
        "view-hpcformation": ViewHpcInformation,
        "view-more": ViewMore,
    },
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
    },
    mounted() {
        // this.getCase();
        this.getSummary()
    },
    data() {
        return {
            text: "Success, Your work has been saved",
            caseid: 0,
            valid: false,
            maincase_id_changestatus: 0,
            no: 1,
            data: [],
            condition: {
                team: this.$route.params.team,
                status: "ViewDetail",
            },
            search: "",
            url: process.env.VUE_APP_ROOT_API,
            data_case: [],
            form: {
                project_id: "",
            },
            pagination: {
                current: 1,
            },
            data_summary: [],
            arr_card: [],
            chk_active_btn: 0,
            num_total: 0,
            dialog: false,
            condition: {
                team: "",
                status: "CloseCase",
                is_skip: true,
            },
            chkstatus: "CloseCase",
        }
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        async getSummary() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/nonhp/waiting-hp/summary`
            try {
                const { data } = await axios.get(`${url}`, options)
                // this.data_summary = data;
                this.arr_card = data

                this.arr_card.map((each) => {
                    this.num_total += parseInt(each.num_cases)
                })
            } catch (error) {
                console.log(error)
            }
        },
        getCase: _.debounce(async function(e) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/nonhp/waiting-hp/pending-case`
            try {
                this.mutateIsLoading()
                const { data } = await axios.post(`${url}`, this.form, options)
                this.pagination.current = data.current_page
                this.data_case = data
                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        }, 1000),
        onPageChange() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            })
            this.getCase()
        },
        selectCard(i, params) {
            this.chk_active_btn = i
            this.form.project_id = params
            this.pagination.current = 1
            this.getCase()
        },
        async view(params) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/casedetail/${params}`
            try {
                const { data } = await axios.get(`${url}`, options)
                this.detailcase = data
                this.dialog = true
            } catch (error) {
                console.log(error)
            }
        },
        async closecase() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/closed-case/${this.detailcase.maincase_id}`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            this.mutateIsLoading()
            const { data } = await axios.post(`${url}`, [], options)
            if (data != "closed - complete") {
                swal({
                    title: "Upload error",
                    icon: "error",
                    button: "OK",
                })
            } else {
                this.dialog = false
                this.getCase()
                this.getSummary()
                this.mutateIsLoading()
            }
        },
    },
}
</script>
